import AccountCircleIcon from '@mui/icons-material/AccountCircle'
import ExitIcon from '@mui/icons-material/ExitToApp'
import PasswordIcon from '@mui/icons-material/LockOpen'
import EmailIcon from '@mui/icons-material/MailOutline'
import {
  Divider,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
} from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import React from 'react'
import { useIntl } from 'react-intl'
import { useGoToHook } from 'services/router/useGoTo.hook'
import { useLogout } from 'services/utils/useLogout.hook'
import { useUserMenuState } from './UserMenu.restate'

import { AppRoutes } from 'routes'
import messages from './userMenu.messages'

const useClasses = makeStyles({
  avatarListItem: {
    minWidth: 250,
  },
  avatar: {
    width: 32,
    height: 32,
  },
})

interface UserMenuProps {
  anchorEl: HTMLElement
  open: boolean
  avatarUrl: string
  userName: string
  eMail: string

  handleClose: () => void
  handleAccount: () => void
  handleEmail: () => void
  handlePassword: () => void
  handleLogout: () => void
}

export const UserMenu: React.FC<UserMenuProps> = props => {
  const intl = useIntl()
  const Password = intl.formatMessage(messages.Password)
  const Logout = intl.formatMessage(messages.Logout)
  const EMail = intl.formatMessage(messages.EMail)

  const {
    open,
    userName,
    eMail,
    handleClose,
    anchorEl,
    handleLogout,
    handleAccount,
    handleEmail,
    handlePassword,
  } = props
  const classes = useClasses()

  return (
    <Menu
      id='user-menu'
      open={open}
      anchorEl={anchorEl}
      onClose={handleClose}
      keepMounted
    >
      <MenuItem className={classes.avatarListItem} onClick={handleAccount}>
        <ListItemIcon>
          <AccountCircleIcon />
        </ListItemIcon>
        <ListItemText primary={userName} secondary={eMail} />
      </MenuItem>

      <Divider />

      <MenuItem onClick={handleEmail}>
        <ListItemIcon>
          <EmailIcon />
        </ListItemIcon>
        <ListItemText primary={EMail} />
      </MenuItem>

      <MenuItem onClick={handlePassword}>
        <ListItemIcon>
          <PasswordIcon />
        </ListItemIcon>
        <ListItemText primary={Password} />
      </MenuItem>

      <Divider />

      <MenuItem onClick={handleLogout}>
        <ListItemIcon>
          <ExitIcon />
        </ListItemIcon>
        <ListItemText primary={Logout} />
      </MenuItem>
    </Menu>
  )
}

const ConnectedUserMenu: React.FC<{
  open: boolean
  handleClose: () => void
}> = ({ open, handleClose }) => {
  const { userName, eMail, avatarUrl } = useUserMenuState(s => s)
  const go = useGoToHook()
  const logout = useLogout()

  const handleMaker = (path: string) => () => {
    handleClose()
    go(path)
  }

  const handleLogout = () => {
    handleClose()
    logout()
  }

  const handleAccount = handleMaker(AppRoutes.MeAccount)
  const handleEmail = handleMaker(AppRoutes.MeEMail)
  const handlePassword = handleMaker(AppRoutes.MePassword)

  const anchorRef = React.useRef<HTMLDivElement>(null)

  return (
    <>
      <div ref={anchorRef}></div>
      {anchorRef.current != null && (
        <UserMenu
          anchorEl={anchorRef.current}
          open={open}
          avatarUrl={avatarUrl}
          userName={userName}
          eMail={eMail}
          handleClose={handleClose}
          handleAccount={handleAccount}
          handleEmail={handleEmail}
          handlePassword={handlePassword}
          handleLogout={handleLogout}
        />
      )}
    </>
  )
}

export default ConnectedUserMenu
